import { Component, inject, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { ProfileService } from "../../../../services/profile.service";
import { DeleteAccountFormComponent } from "../../components/delete-aacount-form/delete-aacount-form.component";
import { ButtonComponent } from "@app/kernel/shared/modules/button/components/button/button.component";
import { SxwFormComponent } from "@app/kernel/form/components/sxw-form/sxw-form.component";
import { DeleteAccountFormModel } from "../../models/delete-account-form.model";
import { SideDialogComponent } from "@app/kernel/popups/popups.config";
import { AuthServiceImpl } from "@app/shared/authentication/services/auth.servcice";

@Component({
  selector: "app-delete-account",
  standalone: true,
  imports: [DeleteAccountFormComponent, TranslateModule, ButtonComponent, SxwFormComponent, SideDialogComponent],
  templateUrl: "./delete-account.component.html",
  styleUrls: ["./delete-account.component.scss"],
  providers: [DeleteAccountFormModel, ProfileService],
})
export class DeleteAccountComponent {
  @ViewChild(SideDialogComponent) sideDialog!: SideDialogComponent;

  isDialogVisible = true;
  isLoading = false;
  private profileService = inject(ProfileService);
  private router = inject(Router);
  public readonly formModel = inject(DeleteAccountFormModel);
  private authService = inject(AuthServiceImpl);

  deleteAccount() {
    this.isLoading = true;
    this.profileService.deleteAccount().subscribe({
      next: () => {
        this.isLoading = false;
        this.closedialog();
      },
    });
  }

  closedialog() {
    this.authService.clearUser();
    this.router.navigate(["auth", "login"]);
  }
}
